import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import {
  CustomTimeRangeCategoriesCollection,
  CustomTimeRangeCategory,
} from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'
import { useFetchCustomTimeRanges } from 'modules/attendance/hooks/useFetchCustomTimeRanges'
import { useFetchTimeSettingsCustomTimeRangeCategories } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import ActiveCategoriesSection from './ActiveCategoriesSection'
import ArchivedCategoriesSection from './ArchivedCategoriesSection'
import BlankSlate from './BlankSlate'

interface Props {
  customTimeRangeCategories: CustomTimeRangeCategoriesCollection
  settingId: number
}

const sortCategories = (categories: CustomTimeRangeCategory[]) =>
  categories.sort((a, b) => a.name.localeCompare(b.name))

const List = ({ customTimeRangeCategories, settingId }: Props) => {
  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()

  const { loading: loadingCustomTimeRangeCategories } =
    useFetchTimeSettingsCustomTimeRangeCategories(currentCompanyId)
  const { ranges: customTimeRanges, loading: loadingCustomTimeRanges } =
    useFetchCustomTimeRanges(settingId)

  const loading = loadingCustomTimeRangeCategories || loadingCustomTimeRanges

  const categoriesWithTimeSettingCategoryArchived =
    customTimeRangeCategories.withTimeSettingCategoryArchived
  const categoriesWithTimeSettingCategoryActive =
    customTimeRangeCategories.withTimeSettingCategoryActive

  const attendanceCategoryIdsFromCustomRanges = new Set(
    customTimeRanges.customTimeRanges.map(
      (timeRange) => timeRange.attendanceCustomTimeRangeCategoryId
    )
  )

  const archivedCategoriesWithTimeBlocks = categoriesWithTimeSettingCategoryArchived.filter(
    (category) => attendanceCategoryIdsFromCustomRanges.has(category.id)
  )

  const hasArchivedCategoriesWithTimeBlocks = archivedCategoriesWithTimeBlocks.length > 0
  const hasActiveCustomTimeRangeCategories = categoriesWithTimeSettingCategoryActive.length > 0

  if (!hasArchivedCategoriesWithTimeBlocks && !hasActiveCustomTimeRangeCategories) {
    return <BlankSlate />
  }

  return (
    <Box gap="s8">
      <ActiveCategoriesSection
        activeCustomTimeRangeCategories={sortCategories(categoriesWithTimeSettingCategoryActive)}
      />
      <ArchivedCategoriesSection
        loading={loading}
        hasActiveCustomTimeRangeCategories={hasActiveCustomTimeRangeCategories}
        archivedCustomTimeRangeCategories={sortCategories(archivedCategoriesWithTimeBlocks)}
      />
    </Box>
  )
}

export default List
